import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useFormContext from '../components/transaction/CrossBorderPayment/form/useFormContext';
import type { ApprovalStatus } from '../generated-types';

const useHandleCrossBorderReload = (paymentStatus?: ApprovalStatus) => {
    const { state } = useFormContext();
    const navigate = useNavigate();

    useEffect(() => {
        if (!state.fromAccount || paymentStatus === 'COMPLETED') {
            navigate('/');
        }
    }, [navigate, paymentStatus, state.fromAccount]);
};

export default useHandleCrossBorderReload;
